module.exports = __webpack_public_path__ + "img/concept-bg2.c51a651e.png";